export default __webpack_public_path__ + "3062c4baa3b8c191b371fe0ea113a5f2.jpg";